import Vue from "vue";
import Vuetify from "vuetify";
import "vuetify/dist/vuetify.min.css";

Vue.use(Vuetify);

// Global Esc listener for all modals
const activeDialogs = [];

function isVDialog(vm) {
  if (!vm || !vm.$options) return false;
  return (
    vm.$options.name === "v-dialog" ||
    vm.$options._componentTag === "v-dialog" ||
    (vm.$vnode &&
      vm.$vnode.componentOptions &&
      vm.$vnode.componentOptions.tag === "v-dialog")
  );
}

if (typeof window !== "undefined") {
  window.addEventListener(
    "keydown",
    (e) => {
      if (e.key === "Escape" || e.keyCode === 27) {
        // If SweetAlert is open, let SweetAlert close first
        if (document.querySelector(".swal2-container.swal2-shown")) {
          return;
        }

        // Clean up stale dialogs and find the topmost active dialog
        let topDialog = null;
        let maxZIndex = -1;

        for (let i = activeDialogs.length - 1; i >= 0; i--) {
          const d = activeDialogs[i];
          if (!d || d._isDestroyed || !d.isActive) {
            activeDialogs.splice(i, 1);
            continue;
          }
          const z = typeof d.activeZIndex === "number" ? d.activeZIndex : 0;
          if (z >= maxZIndex) {
            maxZIndex = z;
            topDialog = d;
          }
        }

        if (topDialog) {
          // If the dialog has open dependent menus/selects, let them handle Esc first
          if (
            typeof topDialog.getOpenDependents === "function" &&
            topDialog.getOpenDependents().length > 0
          ) {
            return;
          }

          topDialog.isActive = false;
          topDialog.$emit("input", false);
          topDialog.$emit("change", false);
          e.preventDefault();
          e.stopPropagation();
          if (typeof e.stopImmediatePropagation === "function") {
            e.stopImmediatePropagation();
          }
          return;
        }

        // Fallback for any dialog elements in the DOM with active class
        const activeContents = document.querySelectorAll(
          ".v-dialog__content--active .v-dialog--active"
        );
        if (activeContents.length > 0) {
          const topmost = activeContents[activeContents.length - 1];
          const closeBtn = topmost.querySelector(
            "button[aria-label='Close'], .v-btn--close, [data-dismiss='modal']"
          );
          if (closeBtn) {
            closeBtn.click();
            e.preventDefault();
            e.stopPropagation();
          }
        }
      }
    },
    true // Capture phase: catches Esc before anything else
  );
}

Vue.mixin({
  mounted() {
    if (isVDialog(this)) {
      if (this.isActive && activeDialogs.indexOf(this) === -1) {
        activeDialogs.push(this);
      }
      this.$watch("isActive", (val) => {
        const idx = activeDialogs.indexOf(this);
        if (val) {
          if (idx === -1) activeDialogs.push(this);
        } else {
          if (idx !== -1) activeDialogs.splice(idx, 1);
        }
      });
    }
  },
  beforeDestroy() {
    if (isVDialog(this)) {
      const idx = activeDialogs.indexOf(this);
      if (idx !== -1) activeDialogs.splice(idx, 1);
    }
  },
});

const opts = {};

export default new Vuetify(opts);



// WEBPACK FOOTER //
// ./src/plugins/vuetify.js